import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
    labels: ['Feyi', 'John', 'Mary'],
    datasets: [
        {
            label: 'Feyi',
            data: [80, 20],
            backgroundColor: ['#006AFF', 'rgba(0,0,0,0.1)'], 
            borderWidth: 2, 
        },
        {
            label: 'John',
            data: [60, 40],
            backgroundColor: ['#ff6666', 'rgba(0,0,0,0.1)'],
            borderWidth: 2, 
        },
        {
            label: 'Mary',
            data: [50, 50],
            backgroundColor: ['#42BD53', 'rgba(0,0,0,0.1)'],
            borderWidth: 2,
        }
    ],
};

const options = {
    cutout: '70%',
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true,  
                pointStyle: 'circle',
                padding: 20, 
                boxWidth: 10,  
                boxHeight: 10, 
                font: {
                    size: 14
                },
                generateLabels: (chart) => {
                    return chart.data.datasets.map((dataset, index) => ({
                        text: chart.data.labels[index],
                        fillStyle: dataset.backgroundColor[0],  // Ensure the legend uses the primary chart color
                        pointStyle: 'circle'
                    }));
                }
            }
        }
    }
};

const TopListenersChart = () => {
    return (
        <div style={{ }}>
            <Doughnut data={data} options={options} />
        </div>
    );
};

export default TopListenersChart;
